import { injectTranslate } from '@core/i18n-legacy';

import { scheduleCellFactory } from '../schedule-cell.component';
import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../offer-columns';

export const scheduledCloseColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.ScheduledClose,
  label: injectTranslate()('app.offers.table.scheduled_close'),
  visible: true,
  geometry: {
    width: 180,
    minWidth: 180,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: false,
    removable: true,
    sortable: false,
  },
  componentFactory: scheduleCellFactory('jobScheduler', 'closeDate'),
}));
